// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zg-button-link[data-v-c9d87d74]{display:inline-block;border-bottom:none}.zg-button-link--full-width[data-v-c9d87d74]{width:100%}@media(max-width: 47.99em){.zg-button-link--full-width-mobile[data-v-c9d87d74]{width:100%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
